import {
  formatISODate,
  futureRelativeToDate,
  pastRelativeToDate
} from '@sequencehq/utils'
import {
  allInvoicePaymentStatuses,
  allInvoiceStatuses,
  toInvoicePaymentStatusBadgeProps,
  toInvoiceStatusBadgeProps
} from '@sequencehq/utils'
import { startOfDay } from '@sequencehq/utils/dates'

export const statusFilterOptions = () => {
  return allInvoiceStatuses.map(status => ({
    label: toInvoiceStatusBadgeProps({ status }).children,
    value: status
  }))
}

export const paymentStatusFilterOptions = () => {
  return allInvoicePaymentStatuses.map(status => ({
    label: toInvoicePaymentStatusBadgeProps({ status }).children,
    value: status
  }))
}

export const sentFilterOptions = [
  {
    label: '1 week ago',
    value: pastRelativeToDate(new Date(), { weeks: 1 })
  },
  {
    label: '1 month ago',
    value: pastRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months ago',
    value: pastRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months ago',
    value: pastRelativeToDate(new Date(), { months: 6 })
  }
]

export const dueBeforeFilterOptions = [
  {
    label: 'Today',
    value: formatISODate(startOfDay(new Date()))
  },
  {
    label: '1 month from now',
    value: futureRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months from now',
    value: futureRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months from now',
    value: futureRelativeToDate(new Date(), { months: 6 })
  }
]

export const dueAfterFilterOptions = [
  {
    label: 'Today',
    value: formatISODate(startOfDay(new Date()))
  },
  {
    label: '1 month ago',
    value: pastRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months ago',
    value: pastRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months ago',
    value: pastRelativeToDate(new Date(), { months: 6 })
  }
]

export const invoiceBeforeFilterOptions = [
  {
    label: 'Today',
    value: formatISODate(startOfDay(new Date()))
  },
  {
    label: '1 month from now',
    value: futureRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months from now',
    value: futureRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months from now',
    value: futureRelativeToDate(new Date(), { months: 6 })
  }
]

export const invoiceAfterFilterOptions = [
  {
    label: 'Today',
    value: formatISODate(startOfDay(new Date()))
  },
  {
    label: '1 month ago',
    value: pastRelativeToDate(new Date(), { months: 1 })
  },
  {
    label: '3 months ago',
    value: pastRelativeToDate(new Date(), { months: 3 })
  },
  {
    label: '6 months ago',
    value: pastRelativeToDate(new Date(), { months: 6 })
  }
]
